export default __webpack_public_path__ + "/src/assets/images/Multi-Attribute-Score-Example-2-table.png";